import axios from "axios"
interface utmData {
  ref?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
  time?: number
}

export const utmCookieRequest = async () => {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const ref = params.get("ref");
  const utm_source = params.get("utm_source");
  const utm_medium = params.get("utm_medium");
  const utm_campaign = params.get("utm_campaign");
  const utm_term = params.get("utm_term");
  const utm_content = params.get("utm_content");
  try {
    let url = `${process.env.THURSDAY_API_BASE_URL}/utm/store`;
    let params: utmData = {};
    if (utm_source) params["utm_source"] = utm_source;
    if (ref) params["ref"] = ref;
    if (utm_medium) params["utm_medium"] = utm_medium;
    if (utm_campaign) params["utm_campaign"] = utm_campaign;
    if (utm_term) params["utm_term"] = utm_term;
    if (utm_content) params["utm_content"] = utm_content;

    if (Object.keys(params).length === 0) return;

    const response = await axios.get(url, 
      { 
        withCredentials: true,
        params 
      }
    );
  } catch (err) {
    console.log("err", err);
  }
};